export default __webpack_public_path__ + "static/media/login.8bb6caa6.svg";